module.exports = __webpack_public_path__ + "img/ideavr-logo.3e6332fc.png";